var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col flex-1 w-full min-h-full overflow-y-auto scrollable"},[(_vm.urlLink)?_c('iframe',{staticClass:"min-h-full w-full",class:_vm.classList,attrs:{"src":_vm.urlLink,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }